import type { Reference } from '../../../../../models';
import type { CommandBody } from '../CrossOriginMessage';

/**
 * Defines the current reference used in application context.
 * Used to set the object creation menu suggestions.
 */
export class ContextCommandBody implements CommandBody {
  /**
   * Current reference in application context.
   */
  context?: Reference;
}
